<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    <v-card class="elevation-10" dense :disabled="dialogLoader">
      <v-card-title class="justify-start primary">
        Usuários
        <v-spacer></v-spacer>
        <v-text-field
            v-model="filter"
            append-icon="mdi-magnify"
            label="Filtrar"
            maxlength="10" 
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
      

      <v-card-text class="pt-5">
          <v-data-table
            :headers="headers"
            :items="usuarios"
            :items-per-page="10"
            class="elevation-0"
            :search="filter"
          >
          <template v-slot:item.roles="{item}">
            {{item.roleListAsString}}
          </template>
          <template v-slot:item.profile="{item}">
            <v-btn large icon color="primary" @click="loadProfile(item)" :disabled="item.profile == null">
              <v-icon>mdi-card-account-details</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.edit="{item}">
            <v-btn large icon color="primary" @click="selectedUser = item; showItemModal = true;">
              <v-icon>mdi-account-edit</v-icon>
            </v-btn>
          </template>  
          <template v-slot:item.delete="{item}">
            <v-btn large icon color="primary" @click="loadToDisable(item)" 
              :disabled="$store.getters.userLogged.id == item.id"
              >
              <v-icon v-if="item.enabled">mdi-account-remove</v-icon>
              <v-icon v-if="!item.enabled">mdi-account-check</v-icon>
            </v-btn>
          </template>  
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="selectedUser = {}; showItemModal = true;"
          class="mb-4 mr-2" color="primary">
          ADICIONAR NOVO
          <v-icon right dark>mdi-account-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <user-modal :item="selectedUser" :showDialog="showItemModal" @close-dialog="closeDialog" />

    <div class="text-center">
      <v-dialog
        v-model="dialogDisable"
        width="500"
      >

        <v-card v-if="selectedUser != null">
          <v-card-title class="subtitle grey lighten-2 pr-2" v-if="selectedUser.enabled">
            Desativar {{selectedUser.fullName}}?
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogDisable = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title class="subtitle grey lighten-2 pr-2" v-if="!selectedUser.enabled">
            Ativar {{selectedUser.fullName}}?
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogDisable = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-5" v-if="selectedUser.enabled">
            Você poderá ativar o usuário novamente depois. Usuários inativos não podem se logar no sistema não são visíveis para outros usuários, mas seus dados de atividades antigas continuam preservados.
          </v-card-text>

          <v-card-text class="pt-5" v-if="!selectedUser.enabled">
            O usuário será ativado e terá acesso ao sistema novamente.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="selectedUser.enabled"
              color="primary"
              text
              @click="changeStatus()"
            >
              Desativar
            </v-btn>
            <v-btn v-if="!selectedUser.enabled"
              color="primary"
              text
              @click="changeStatus()"
            >
              Ativar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="dialogProfile"
        width="500"
      >    

        <v-card v-if="selectedUser != null && selectedUser.profile != null">
          <v-card-title class="subtitle grey lighten-2 pr-2">
            Profile de {{selectedUser.fullName}}
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogProfile = false; selectUser = null;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-5" v-if="selectedUser.enabled">
            
            <v-row v-if="selectedUser.profile.media != null" class="text-center">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                <v-avatar class="" size="200">
                  <img :src="selectedUser.profile.media.url">
                </v-avatar>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="text-center">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                {{selectedUser.profile.frase}}
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="text-center" v-if="selectedUser.profile.professor != null">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                Coach: {{selectedUser.profile.professor.fullName}}
              </v-col>
            </v-row>


          </v-card-text>

          <v-divider></v-divider>

         
        </v-card>
      </v-dialog>
    </div>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Carregando...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
import UserModal from '../components/UserModal.vue';

import HOST from '../ws'

export default {
  components: { UserModal },

  props: {
    source: String
  },
  data: () => ({

    dialogLoader : false,

    myHost : HOST.HOST,

    filter : '',

    //dialogs:
    dialogEditUser : false,
    dialogDisable : false,
    dialogProfile : false,
    showItemModal : false,

    //tabelas dos usuarios:
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: true,
        value: 'fullName',
      },
      {
        text: 'Email',
        align: 'center',
        sortable: true,
        value: 'email',
      },
      {
        text: 'Data de Criação',
        align: 'center',
        sortable: true,
        value: 'dtCreated',
      },
      {
        text: 'Perfis',
        align: 'center',
        sortable: false,
        value: 'roles',
      },
      {
        text: 'Profile',
        align: 'center',
        sortable: false,
        value: 'profile',
      },
      {
        text: 'Editar',
        align: 'center',
        sortable: false,
        value: 'edit',
      },
      {
        text: 'Ativar/Desativar',
        align: 'center',
        sortable: false,
        value: 'delete',
      },
    ],

    //usuarios:
    usuarios : [],

    //usuario selecionado:
    selectedUser : null,

    
  }),
  mounted() {
    
    this.selectedUser = null;
    this.reloadUserList();
  },
  methods : {

    closeDialog(){
      //this.$emit('close-dialog', false);
      this.showItemModal = false;
      this.selectedUser = null;
      this.reloadUserList();
    },

    reloadUserList(){

      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/all', {}, config)
      .then(response => {
        this.usuarios = response.data;
        this.dialogLoader = false;
      })
      .catch((error) => {
         console.log(error.message);
         this.dialogLoader = false;
         this.$store.commit('logout');
         this.$router.push("login");
      });
    },
    deleteUser(val){
      this.selectedUser = val;
      this.dialogEditUser = true;
    },
    loadToDisable(val){
      this.selectedUser = val;
      this.dialogDisable = true;
    },
    loadProfile(val){
      this.selectedUser = val;
      this.dialogProfile = true;
    },
    changeStatus(){

      if(this.selectedUser != null){

        this.axios({
          method: 'post',
          url : this.myHost + '/user/changestatus', 
          headers: {
              'Content-Type' : 'application/json',
              Authorization: `Bearer ${this.$store.state.currentToken}`},           
              data : JSON.stringify(this.selectedUser)
        })
        .then(response => {
          console.log(response.data.fullName);
          this.reloadUserList();
          this.dialogDisable = false;
        })
        .catch((error) => {
          console.log(error.message);
          this.$store.commit('logout');
          this.$router.push("login");
        });
        
      }
    }
  }
};
</script>
